import { CompanionError } from './_internal/error/CompanionError';
export const formats = {
    KB: Math.pow(1000, 1),
    KiB: Math.pow(1024, 1),
    MB: Math.pow(1000, 2),
    MiB: Math.pow(1024, 2),
    GB: Math.pow(1000, 3),
    GiB: Math.pow(1024, 3),
};
/**
 * Global configuration object
 */
let _CONFIG = {
    // 55 minutes, tokens expire in 60 minutes.
    AUTH_EXPIRY_MS: 55 * 60 * 1000,
    AUTH_AUTO_REFRESH: true,
    AUTH_MFA_COOKIE_IDENTIFIER: 'mfaAuth',
    // 3 retries
    UPLOAD_MPU_MAX_TRIES: 3,
    // 3000ms between retries
    UPLOAD_MPU_TIME_BETWEEN_RETRIES: 3000,
    AUTH_FROM_ADMIN_KEY: 'auth-from-admin',
    // 5Gb
    UPLOAD_S3_MAX_SIZE: 5 * formats.GB,
    // 2 MiB (taken from dashboard chunkservice)
    UPLOAD_MPU_CHUNK_SIZE: 2 * formats.MiB,
    // Minimal part size is 5MB
    UPLOAD_V2_MPU_PART_SIZE: 10 * formats.MB,
    // 10000 is hard limit for the api
    UPLOAD_V2_MPU_MAX_PARTS: 10000,
    UPLOAD_V2_MPU_MAX_CONCURRENT_PARTS: 3,
    UPLOAD_V2_DIRECT_MAX_SIZE: 100 * formats.MB,
};
/**
 * Set the configuration
 *
 * @param keyOrConfig Either the key of the value that is being set, or an object containing the entire config
 * @param value The value that goes with the key. Should be omitted if keyOrConfig is an object.
 */
// biome-ignore lint/suspicious/noExplicitAny: let it go
export function setConfig(keyOrConfig, value) {
    if (typeof keyOrConfig === 'string') {
        // Set on config object
        _CONFIG[keyOrConfig] = value;
    }
    else {
        // Merge config objects
        _CONFIG = Object.assign(Object.assign({}, _CONFIG), keyOrConfig);
    }
}
/**
 * Get a copy of the entire configuration.
 */
export function getConfig() {
    // Always return copy to prevent accidental mutation
    return Object.assign({}, _CONFIG);
}
/**
 * Get the config value for the specified key.
 *
 * In case the provided key can't be found, an error will be thrown.
 *
 * @param key The key for the value that needs to be retrieved
 */
export function getConfigValueOrThrow(key) {
    const val = _CONFIG[key];
    if (typeof val === 'undefined') {
        throw new CompanionError({
            error: new Error(`Missing config variable '${key}'`),
            code: 'MISSING_KEY',
        });
    }
    return val;
}
getConfigValueOrThrow.ERR = {
    MISSING_KEY: 'MISSING_KEY',
};
